
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-pigment-css",
      function () {
        return require("private-next-pages/blog/introducing-pigment-css.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-pigment-css"])
      });
    }
  